// extracted by mini-css-extract-plugin
module.exports = {"btnLabel":"ConfirmReception_btnLabel__Zwb8I"};